import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminCheck } from "@/hooks/useAdminCheck";

interface Props {
  children: ReactNode;
}

const RequireAdmin = ({ children }: Props) => {
  const { user, isAdmin, loading } = useAdminCheck();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth?redirect=${redirect}`} replace />;
  }

  if (!isAdmin) return <Navigate to="/" replace />;

  return <>{children}</>;
};

export default RequireAdmin;